module.exports = __webpack_public_path__ + "img/hhIcon.a508e6df.png";